import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAvailableDates } from 'common/tourHelpers';
import branch from 'client/core/branch';

@branch({
  availableTourDates: ['availableTourDates'],
  unavailableTourDates: ['unavailableTourDates'],
})
class SrCalendarDaySlider extends Component {
  static propTypes = {
    selectedDate: PropTypes.string,
    availableTourDates: PropTypes.array,
    unavailableTourDates: PropTypes.array,
    isSunroomListing: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    availableTourDates: [],
  };

  constructor(props) {
    super(props);

    const { availableTourDates, unavailableTourDates, selectedDate, isSunroomListing } = props;
    const initialState = {
      selectedDate: selectedDate,
    };

    if (!selectedDate) {
      const availableDate = getAvailableDates({
        availableTourDates: availableTourDates || [],
        unavailableTourDates: unavailableTourDates || [],
        isSunroomListing,
      }).find(({ disabled }) => !disabled);
      if (availableDate) {
        initialState.selectedDate = availableDate.date;
      }
    }

    this.state = initialState;
  }

  componentDidMount() {
    this._onChange(this.state.selectedDate);
  }

  _onChange = (selectedDate) => {
    this.setState({
      selectedDate,
    });
    this.props.onChange(selectedDate);
  };

  render() {
    const { selectedDate } = this.state;
    const { availableTourDates, unavailableTourDates, isSunroomListing } = this.props;
    const availableDates = getAvailableDates({
      availableTourDates: availableTourDates || [],
      unavailableTourDates: unavailableTourDates || [],
      isSunroomListing,
    });

    const calendar = availableDates.map((dateInfo) => (
      <div
        key={dateInfo.date}
        className={classNames('dayContainer', {
          active: selectedDate === dateInfo.date,
          disabled: dateInfo.disabled,
        })}
        onClick={() => this._onChange(dateInfo.date)}
      >
        <span className='dayName'>
          {dateInfo.disabled ? 'not available' : dateInfo.dayString}
        </span>
        <span className='dayNumber'>{dateInfo.dayNumber}</span>
        <span className='month'>{dateInfo.month}</span>
      </div>
    ));

    return <div className='sliderContainer'>{calendar}</div>;
  }
}

export default SrCalendarDaySlider;
